define('auth-media-gateway/subclasses/SoapObject',['require','exports','module'],function(require, exports, module){
		
	function SoapObject(name) {
		this.typeOf="SOAPObject";
		this.ns=null;
		this.name=name;
		this.attributes=[];
		this.children=[];
		this.value=null;
		this.attr=function(name, value){this.attributes.push({"name":name, "value":value});return this;};
		this.appendChild=function(obj){this.children.push(obj);return obj;};
		this.hasChildren=function(){return (this.children.length > 0)?true:false;};
		this.val=function(v){if(!v){return this.value;}else{this.value=v;return this;}};
		this.ToXML = function(soapObj) {
			var out = "";
			var isNSObj=false;
			try {
				if(!!soapObj&&typeof(soapObj)==="object"&&soapObj.typeOf==="SOAPObject") {
					//Namespaces
					if(!!soapObj.ns) {
						if(typeof(soapObj.ns)==="object") {
							isNSObj=true;
							out += "<"+soapObj.ns.name+":"+soapObj.name;
							out += " xmlns:"+soapObj.ns.name+"=\""+soapObj.ns.uri+"\"";
						} else {
							out += "<"+soapObj.name;
							out += " xmlns=\""+soapObj.ns+"\"";
						}
					} else {
						out += "<"+soapObj.name;
					}
					//Node Attributes
					if(soapObj.attributes.length > 0) {
						 var cAttr;
						 var aLen=soapObj.attributes.length-1;
						 do {
							 cAttr=soapObj.attributes[aLen];
							 if(isNSObj) {
								out += " "+soapObj.ns.name+":"+cAttr.name+"=\""+cAttr.value+"\"";
							 } else {
								out += " "+cAttr.name+"=\""+cAttr.value+"\"";
							 }
						 } while(aLen--);
					}
					out += ">";
					//Node children
					if(soapObj.hasChildren()) {
						var cPos, cObj;
						for(cPos in soapObj.children){
							if (!soapObj.children.hasOwnProperty || soapObj.children.hasOwnProperty(cPos)) {
								cObj = soapObj.children[cPos];
								if(typeof(cObj) === "object"){out += _self.SOAPClient.ToXML(cObj);}
							}
						}
					}
					//Node Value
					if(!!soapObj.value){out += soapObj.value;}
					//Close Tag
					if(isNSObj){out += "</"+soapObj.ns.name+":"+soapObj.name+">";}
					else {out += "</"+soapObj.name+">";}
					return out;
				}
			} catch(e){throw new Error("Unable to process SOAPObject! Object must be an instance of SOAPObject");}
		}
	}
	
	return SoapObject;
});
